import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectProfile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      profiles: props.profiles,
      default_profiles: props.default_profiles,
      element_id: props.element_id,
      multiple: props.multiple,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectProfile() {
    let debounceTimer;
    const account = this.state.account;
    const profiles = this.state.profiles;
    const default_profiles = this.state.default_profiles;
    const element_id = this.state.element_id;
    const multiple = this.state.multiple;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        profiles: value,
      });
      if (multiple) {
        let result = value.map((tag) => tag.id);
        document.getElementById(element_id).value = JSON.stringify(result);
      } else {
        document.getElementById(element_id).value = value ? value.id : null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/profiles/select?search=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if (!profiles && (!default_profiles || default_profiles.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ default_profiles: options });
        });
      }
    };

    const customOption = (profile) => {
      return (
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              {profile["title"]}
            </div>
            {profile["badge"] && <div className="ml-auto small">
              {profile["badge"]}
            </div>}
          </div>
          {profile["description"] && <div className="small select-description">
            {profile["description"]}
          </div>}
        </div>
      );
    }

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={default_profiles}
        isMulti={multiple}
        placeholder={this.props.placeholder || "Select a user..."}
        value={profiles}
        getOptionLabel={c => customOption(c)}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        isClearable
        styles={{
          singleValue: (base) => ({ ...base, width: '96%' }),
          valueContainer: (base) => ({ ...base, minHeight: '44px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectProfile()}
      </div>
    );
  }
}

SelectProfile.propTypes = {
  account: PropTypes.object,
  profiles: PropTypes.object,
  default_profiles: PropTypes.array,
  element_id: PropTypes.string,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
};
export default SelectProfile;
